import { TiArrowBackOutline } from 'react-icons/ti';
import { WiCloudyGusts } from 'react-icons/wi';
import { WiCloudy } from 'react-icons/wi';
import { WiDayCloudyGusts } from 'react-icons/wi';
import { WiDayCloudyWindy } from 'react-icons/wi';
import { WiDayCloudy } from 'react-icons/wi';
import { WiDayFog } from 'react-icons/wi';
import { WiDayHail } from 'react-icons/wi';
import { WiDayHaze } from 'react-icons/wi';
import { WiDayLightning } from 'react-icons/wi';
import { WiDayRainMix } from 'react-icons/wi';
import { WiDayRainWind } from 'react-icons/wi';
import { WiDayShowers } from 'react-icons/wi';
import { WiDaySleetStorm } from 'react-icons/wi';
import { WiDaySnowThunderstorm } from 'react-icons/wi';
import { WiDaySnow } from 'react-icons/wi';
import { WiDaySunny } from 'react-icons/wi';
import { WiFog } from 'react-icons/wi';
import { WiHorizonAlt } from 'react-icons/wi';
import { WiFire } from 'react-icons/wi';
import { WiLightning } from 'react-icons/wi';

export const categories = [
    { name: '코딩애플', icon: <TiArrowBackOutline /> },
    { name: '코딩앙마', icon: <WiCloudyGusts /> },
    { name: '노마드코더', icon: <WiCloudy /> },
    { name: '코딩알려주는누나', icon: <WiDayCloudyGusts /> },
    { name: '드림코딩', icon: <WiDayCloudyWindy /> },
    { name: '생활코딩', icon: <WiDayCloudy /> },
    { name: '웹스토리보이', icon: <WiDayFog /> },
    { name: '뉴진스', icon: <WiDayHail /> },
    { name: '얄팍한 코딩사전', icon: <WiDayHaze /> },
    { name: '나도 코딩', icon: <WiDayLightning /> },
    { name: '개발자의 품격', icon: <WiDayRainMix /> },
    { name: '개발하는 남자', icon: <WiDayRainWind /> },
    { name: '1분코딩', icon: <WiDayShowers /> },
    { name: '조코딩', icon: <WiDaySleetStorm /> },
    { name: 'freeCodeCamp', icon: <WiDaySnowThunderstorm /> },
    { name: '코딩하는거니', icon: <WiDaySnow /> },
    { name: 'Chris Courses', icon: <WiDaySunny /> },
    { name: 'Rocks Easyweb', icon: <WiFog /> },
    { name: 'hyosung lim임효성', icon: <WiHorizonAlt /> },
    { name: '제주코딩베이스캠프', icon: <WiFire /> },
    { name: '김버그 kimbug', icon: <WiLightning /> },
];
